export const arr = [
  {
    id: 0,
    date: '29 June, Thu',
    team1: 'ENG',
    team2: 'GER',
    team3: 'SWE',
    team4: 'UKR',
    flag1: 'https://www.uefa.com/imgml/flags/70x70/ENG.png?imwidth=158',
    flag2: 'https://www.uefa.com/imgml/flags/70x70/GER.png?imwidth=158',
    flag3: 'https://www.uefa.com/imgml/flags/70x70/SWE.png?imwidth=158',
    flag4: 'https://www.uefa.com/imgml/flags/70x70/UKR.png?imwidth=158',
    score1: '2',
    score2: '0',
    score3: '1',
    score4: '2',
  },
  {
    id: 1,
    date: '28 June, Mon',
    team1: 'CRO',
    team2: 'SPA',
    team3: 'FRA',
    team4: 'SWI',
    flag1: 'https://www.uefa.com/imgml/flags/70x70/CRO.png?imwidth=158',
    flag2: 'https://www.uefa.com/imgml/flags/70x70/ESP.png?imwidth=158',
    flag3: 'https://www.uefa.com/imgml/flags/70x70/FRA.png?imwidth=158',
    flag4: 'https://www.uefa.com/imgml/flags/70x70/SUI.png?imwidth=158',
    score1: '3',
    score2: '5',
    score3: '3',
    score4: '3',
  },
  {
    id: 2,
    date: '27 June, Sun',
    team1: 'NET',
    team2: 'CZE',
    team3: 'BEL',
    team4: 'POR',
    flag1: 'https://www.uefa.com/imgml/flags/70x70/NED.png?imwidth=158',
    flag2: 'https://www.uefa.com/imgml/flags/70x70/CZE.png?imwidth=158',
    flag3: 'https://www.uefa.com/imgml/flags/70x70/BEL.png?imwidth=158',
    flag4: 'https://www.uefa.com/imgml/flags/70x70/POR.png?imwidth=158',
    score1: '0',
    score2: '2',
    score3: '1',
    score4: '0',
  },
  {
    id: 3,
    date: '26 June, Sat',
    team1: 'WAL',
    team2: 'DEN',
    team3: 'ITA',
    team4: 'AUS',
    flag1: 'https://www.uefa.com/imgml/flags/70x70/WAL.png?imwidth=158',
    flag2: 'https://www.uefa.com/imgml/flags/70x70/DEN.png?imwidth=158',
    flag3: 'https://www.uefa.com/imgml/flags/70x70/ITA.png?imwidth=158',
    flag4: 'https://www.uefa.com/imgml/flags/70x70/AUT.png?imwidth=158',
    score1: '0',
    score2: '4',
    score3: '2',
    score4: '1',
  },
];
